import { lazy, Suspense } from "react";

import { Navigate, Route, Routes, useParams } from "react-router-dom";

import LoaderComponent from "../Components/Common/Loader/Loader";
import PermissionRoute from "./PermissionRoute";
import { PERM, ANY_QUOTE_ACCESS } from "../Utils/access/permissionConstants";
import ManualUnderwriting from "../Pages/Manual Underwriting";
import EmailQuoteHandler from "../Components/Quotes/EmailQuoteHandler";

const NotFound = lazy(() => import("../Pages/404"));
const Main = lazy(() => import("../Components/Common/Template/Index"));
const Dashboard = lazy(() => import("../Pages/Dashboard/Index"));
const Prospects = lazy(() => import("../Pages/Prospects/Index"));
const Quotes = lazy(() => import("../Pages/Quotes/Index"));
const Clients = lazy(() => import("../Pages/Clients/Index"));
const ClientCompany = lazy(() => import("../Pages/Clients/CompanyView"));
const Claims = lazy(() => import("../Pages/Claims/Index"));
const ClaimsOverdiv = lazy(() => import("../Pages/Claims/Index"));
const Renewals = lazy(() => import("../Pages/Renewals/Index"));
const Commissions = lazy(() => import("../Pages/Commissions/Index"));
const SalesToolkit = lazy(() => import("../Pages/Sales Toolkit/Index"));
const Support = lazy(() => import("../Pages/Support/Index"));
const Settings = lazy(() => import("../Pages/Settings/Index"));
// const CreateNewQuote = lazy(() => import("../Pages/Create New Quote/Index"));
const AddNewLeads = lazy(() => import("../Pages/Add New Leads/Index"));
const Notifications = lazy(() => import("../Pages/Notifications/Index"));
const Messages = lazy(() => import("../Pages/Messages/Index"));
const Profile = lazy(() => import("../Pages/Profile/Index"));
const Login = lazy(() => import("../Pages/Login/Index"));
const Users = lazy(() => import("../Pages/Users"));
const QouteSummary = lazy(() => import("../Components/Quotes/Summary"));
const QuoteDetail = lazy(() => import("../Components/Quotes/QuoteDetail"));
const RenewalQuoteDetail = lazy(() => import("../Components/Quotes/RenewalQuoteDetail"));

const HealthInsurance = lazy(() => import("../Pages/HealthInsurance/Index"));
const ProActiv = lazy(() => import("../Pages/ProActiv/Index"));
const Health_ProActiv = lazy(() => import("../Pages/Health_ProActiv/Index"));
const Terms_Conditions = lazy(() => import("../Pages/Terms_Conditions"));
const ManualUnderwritingForm = lazy(() => import("../Pages/Manual Underwriting"));
const AuditLog = lazy(() => import("../Pages/AuditLog/Index"));
const PaymentGateway=lazy(()=>import("../Components/payment_gateway"));
const PolicyDetails=lazy(()=>import("../Pages/Clients/Details"));
const AcceptManualQuote=lazy(()=>import("../Pages/Quotes/AcceptManualQuote"));
const PolicyBindingPage=lazy(()=>import("../Pages/Quotes/PolicyBindingPage"));
const DebtManagement=lazy(()=>import("../Pages/Debt_Management"));
const ManualQuoteDetailsPage=lazy(()=>import("../Pages/Quotes/ManualQuoteDetailsPage"));
const SalesPerformance=lazy(()=>import("../Pages/SalesPerformance/Index"));

const Index = () => {
  const { policyNumber, company } = useParams();
  return (
    <Suspense fallback={<LoaderComponent />}>
      <Routes>
        <Route
          path="/"
          element={
            <PermissionRoute>
              <Dashboard />
            </PermissionRoute>
          }
        />

        {/* Email quote action handlers */}
        <Route
          path="/email/quote-accept/*"
          element={<EmailQuoteHandler />}
        />
        <Route
          path="/email/quote-request/*"
          element={<EmailQuoteHandler />}
        />
        <Route
          path="/email/quote-download/*"
          element={<EmailQuoteHandler />}
        />

        {/*  */}
        <Route
          path="/manual-quote"
          element={
            <PermissionRoute requiredAny={ANY_QUOTE_ACCESS}>
              <ManualUnderwritingForm />
            </PermissionRoute>
          }
        />

        <Route
          path="/create-quote/health-insurance"
          element={
            <PermissionRoute requiredAny={ANY_QUOTE_ACCESS}>
              <HealthInsurance />
            </PermissionRoute>
          }
        />
        <Route
          path="/create-quote/pro-activ"
          element={
            <PermissionRoute requiredAny={ANY_QUOTE_ACCESS}>
              <ProActiv />
            </PermissionRoute>
          }
        />
        <Route
          path="/create-quote/health-proactiv"
          element={
            <PermissionRoute requiredAny={ANY_QUOTE_ACCESS}>
              <Health_ProActiv />
            </PermissionRoute>
          }
        />
        <Route
          path="/debt-management"
          element={
            <PermissionRoute
              requiredAny={[PERM.GET_DEBT_MANAGMENT]}
            >
              <DebtManagement />
            </PermissionRoute>
          }
        />
        <Route
          path="/accept-manual-quote"
          element={
            <PermissionRoute requiredAny={ANY_QUOTE_ACCESS}>
              <AcceptManualQuote />
            </PermissionRoute>
          }
        />
        <Route
          path="/policy-binding/:id"
          element={
            <PermissionRoute requiredAny={ANY_QUOTE_ACCESS}>
              <PolicyBindingPage />
            </PermissionRoute>
          }
        />

        {/*  */}

        <Route path="/login" element={<Login />} />
        <Route
          path="/prospects"
          element={
            <PermissionRoute requiredAny={[PERM.GET_LEADS]}>
              <Prospects />
            </PermissionRoute>
          }
        />
        <Route
          path="/quotes"
          element={
            <PermissionRoute requiredAny={ANY_QUOTE_ACCESS}>
              <Quotes />
            </PermissionRoute>
          }
        />
        <Route
          path="/manual-quote-details/:id"
          element={
            <PermissionRoute requiredAny={ANY_QUOTE_ACCESS}>
              <ManualQuoteDetailsPage />
            </PermissionRoute>
          }
        />
        <Route
          path="/quote/:qouteId"
          element={
            <PermissionRoute requiredAny={ANY_QUOTE_ACCESS}>
              <Quotes />
            </PermissionRoute>
          }
        />
        <Route
          path="/policies"
          element={
            <PermissionRoute requiredAny={[PERM.GET_POLICIES]}>
              <Clients />
            </PermissionRoute>
          }
        />
          <Route
          path="/policies/:policyId"
          element={
            <PermissionRoute requiredAny={[PERM.GET_POLICIES]}>
              <PolicyDetails />
            </PermissionRoute>
          }
        />
            <Route
          path="/payment-gateway"
          element={
            <PermissionRoute requiredAny={ANY_QUOTE_ACCESS}>
              <PaymentGateway />
            </PermissionRoute>
          }
        />
        <Route
          path="/clients/:company"
          element={
            <PermissionRoute requiredAny={[PERM.GET_POLICIES]}>
              <ClientCompany />
            </PermissionRoute>
          }
        />
        <Route
          path="/claims"
          element={
            <PermissionRoute>
              <Claims />
            </PermissionRoute>
          }
        />
        <Route
          path="/claims/:policyNumber"
          element={
            <PermissionRoute>
              <Claims />
            </PermissionRoute>
          }
        />
        <Route
          path="/renewals"
          element={
            <PermissionRoute>
              <Renewals />
            </PermissionRoute>
          }
        />
        <Route
          path="/commissions"
          element={
            <PermissionRoute requiredAny={[PERM.GET_COMMISSIONS]}>
              <Commissions />
            </PermissionRoute>
          }
        />
        <Route
          path="/salestoolkit"
          element={
            <PermissionRoute>
              <SalesToolkit />
            </PermissionRoute>
          }
        />
        <Route
          path="/support"
          element={
            <PermissionRoute>
              <Support />
            </PermissionRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <PermissionRoute>
              <Settings />
            </PermissionRoute>
          }
        />
      
        {/* <Route
          path="/createnewquote"
          element={
            <PermissionRoute>
              <CreateNewQuote />
            </PermissionRoute>
          }
        /> */}
        {/* <Route path="/addnewleads" element={<AddNewLeads />} /> */}
        {/* <Route path="/notifications" element={<Notifications />} /> */}
        {/* <Route path="/messages" element={<Messages />} /> */}
        <Route
          path="/profile"
          element={
            <PermissionRoute>
              <Profile />
            </PermissionRoute>
          }
        />
        <Route
          path="/users"
          element={
            <PermissionRoute requirePrivileged>
              <Users />
            </PermissionRoute>
          }
        />
        <Route
          path="/terms&conditions"
          element={
            <PermissionRoute>
              <Terms_Conditions />
            </PermissionRoute>
          }
        />
        <Route
          path="/sales-performance"
          element={
            <PermissionRoute>
              <SalesPerformance />
            </PermissionRoute>
          }
        />
        <Route
          path="/audit-log"
          element={
            <PermissionRoute
              requiredAny={[PERM.ACCESS_CONTROL]}
              orPrivilege
            >
              <AuditLog />
            </PermissionRoute>
          }
        />

        <Route
          path="/quote-detail/:quoteId"
          element={
            <PermissionRoute requiredAny={ANY_QUOTE_ACCESS}>
              <QuoteDetail />
            </PermissionRoute>
          }
        />

        <Route
          path="/renewal-quote-detail/:quoteId"
          element={
            <PermissionRoute requiredAny={ANY_QUOTE_ACCESS}>
              <RenewalQuoteDetail />
            </PermissionRoute>
          }
        />
     
        <Route
          path="*"
          element={
            <PermissionRoute>
              <NotFound />
            </PermissionRoute>
          }
        />
      </Routes>
    </Suspense>
  );
};

export default Index;
